module.exports = __webpack_public_path__ + "img/ico-money.134fe081.svg";